export enum BrandSection {
  TOP = 'brand-top',
  DESCRIPTION = 'brand-description',
  EVENTS = 'brand-events',
  DEDICATED = 'brand-dedicated',
}
